import { SyntheticEvent } from "react";
import { COAST_CATEGORIES } from "@inferno/renderer-shared-core";

interface CategoryItem {
  name: string;
  displayName: string;
}

interface CoastFeedCategorySelectorProps {
  handleChange(e: SyntheticEvent): void;
  displayHostCategories: boolean;
  selectedCategory?: string;
  dynamicHosts?: CategoryItem[];
  dynamicTopics?: CategoryItem[];
}

const getOptionsList = (tags: typeof COAST_CATEGORIES.regular) =>
  tags.map(tag => (
    <option key={tag.name} label={tag.displayName} value={tag.name}>
      {tag.displayName}
    </option>
  ));

export const CoastFeedCategorySelector = ({
  displayHostCategories,
  selectedCategory,
  handleChange,
  dynamicHosts = [],
  dynamicTopics = [],
}: CoastFeedCategorySelectorProps) => {
  // Combine static and dynamic topics
  const allTopics = [...dynamicTopics];
  // Combine static and dynamic hosts
  const allHosts = displayHostCategories ? [...dynamicHosts] : [];

  return (
    <div className="coast-feed-navigation-filter">
      {/* Using onBlur here makes react mad */}
      {/* eslint-disable-next-line jsx-a11y/no-onchange */}
      <select name="category" onChange={handleChange} value={selectedCategory}>
        <option key="all" label="All Categories" value="all-categories">
          All Categories
        </option>

        {getOptionsList(allTopics)}

        {allHosts.length > 0 && <optgroup label="By Host">{getOptionsList(allHosts)}</optgroup>}
      </select>
    </div>
  );
};
